import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {PaketService} from './service/paket.service';
import {GezeichneteProdukte, MaklerPaket} from './service/Model/MaklerPaket';
import {MaklerPaketStatusService} from './service/detail.service';
import {CsvUploadService} from './service/csv-upload.service';
import {AdminService} from "../admin/services/admin.service";
import {MaklerPaketStatus} from "./service/Model/MaklerPaketStatus";
import {environment} from '../../../environments/environment';
import {Geschaeftsvorgang, Lieferung} from "./service/Model/Lieferung";
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-uploadpakete-main',
  templateUrl: './app.uploadpakete.main.html',
  styleUrls: ['./app.uploadpakete.main.scss'],
})
export class AppUploadpaketeMainComponent implements OnInit {

  maklerPackets: MaklerPaket[];
  maklerPaket : MaklerPaket;
  maklerStatus : MaklerPaketStatus;
  gezeichneteProd : GezeichneteProdukte;
  fileSelectMsg: string = 'No file selected yet.';
  fileUploadMsg: string = 'No file uploaded yet.';
  disabled: boolean = false;

  ngOnInit(): void {
    // debugger;
    console.log("ngInit AppUploadpaketeMainComponent");
    this.adminService.findMaklerPakete()
      .subscribe(
        (result: MaklerPaket[]) => {
          console.log("to result?");
          if (result != null) {
            this.maklerPackets = JSON.parse(JSON.stringify(result));
            this.maklerPaket = this.maklerPackets[0];
            this.gezeichneteProd = this.maklerPackets[0].gezeichneteProdukte[0];
            console.log(this.maklerPaket.gezeichneteProdukte[0].bezeichnung+" , "+this.maklerPaket.gezeichneteProdukte[1].bezeichnung);
            console.log(result);
            console.log("this.maklerPackets: " + this.maklerPackets);
          }
        }
      );
  }

  packages: MaklerPaket[];

  maklerPaketStatusDetails: Lieferung[];
  lieferungBis : any = new Date();
  lieferungVon : any = new Date(new Date().getTime()-30*86400000);
  gfEinzeln : Geschaeftsvorgang;

  //TODO make clear why these are here
  public showConfirmationCard: boolean;
  public accept: boolean;
  public showErrorMsg: boolean = false;

  public errorOccurredWhileLoadingData: boolean = false;

  public isUploadToolbar: boolean = true;
  public isStatusDisplayToolbar: boolean = false;
  public isStatusDisplayMainPage: boolean = false;
  public isReadyForUpload: boolean = false;

  private fileForUpload: File;
  @Input() showElmt: boolean;

  @Output()
  public change: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private packageService: PaketService,
              private adminService: AdminService,
              private paketStatusService: MaklerPaketStatusService,
              private snackBar: MatSnackBar,
              private csvUploadService: CsvUploadService,) {
    this.accept = false;
    this.showErrorMsg = false;
    this.showConfirmationCard = false;
  }

  chooseMaklerPaket(value: string): void {
    console.log("value chooseMaklerPaket");
     this.maklerPaket = this.maklerPackets.find(x => x.text === value);
  }

  chooseBranche(value: string): void {
    this.gezeichneteProd = this.maklerPaket.gezeichneteProdukte.find(x => x.bezeichnung === value);
  }

  showUploadToolbar(): void {
    this.isUploadToolbar = true;
    this.isStatusDisplayToolbar = false;
    this.isReadyForUpload = false;
  }

  backToMaklerAllianz() {
    return document.location.href=`${environment.backUrl}`;
  }

  showStatusDisplayToolbar(): void {
    this.isStatusDisplayMainPage=false;
    this.isStatusDisplayToolbar = true;
    this.isUploadToolbar = false;
    this.isReadyForUpload = false;
    this.maklerPaketStatusDetails = null;
    // this.initializePackageStatusDisplay();
  }

  initializePackageStatusDisplay() {
    this.loadPackages();
  }

  private loadPackages() {
    this.packageService.getPackages().subscribe((packages) => {
      this.packages = packages;
      console.log("Got maklerPaketStatusInput");
    }, (error) => {
      this.errorHandling(error);
    });
  }


  private errorHandling(error) {
    this.showErrorMsg = true;
    console.log(error);
  }

  public static calculateNumberArray(numberOfSites: number): number[] {
    const tmpArray = [];
    for (let i = 0; i < numberOfSites; i++) {
      tmpArray.push(i);
    }
    return tmpArray;
  }



  loadProcessesTo() {
    this.showStatusDisplayToolbar();
    this.paketStatusService.getPaketStatus(this.maklerPaket.wert, this.lieferungVon, this.lieferungBis)
      .subscribe(
        (result) => {
          if(result!=null){
            this.maklerPaketStatusDetails = result;
            this.gfEinzeln = this.maklerPaketStatusDetails[0].geschaeftsvorgangs[0];
            console.log("anliegenId" + this.gfEinzeln);
          }
          else{
            this.snackBar.open("Im gewählten Zeitraum sind sind keine Informationen zu Datenlieferungen vorhanden!", null, {duration: 2000, panelClass: ["bgc-red-400"]});
          }
        },
        (error) => {
          this.snackBar.open("Im gewählten Zeitraum sind sind keine Informationen zu Datenlieferungen vorhanden!", null, {duration: 2000, panelClass: ["bgc-red-400"]});
        }
      );
  }

  changeListener(files: FileList): void {
    this.checkIfIsCSVType(files);
  }

  selectEvent(file: File): void {
    this.fileSelectMsg = file.name;
  }

  uploadEvent(file: File): void {
    this.fileUploadMsg = file.name;
  }

  cancelEvent(): void {
    this.fileSelectMsg = 'No file selected yet.';
    this.fileUploadMsg = 'No file uploaded yet.';
  }

  toggleDisabled(): void {
    this.disabled = !this.disabled;
  }

  private checkIfIsCSVType(inputValue: FileList): void {
    const file: File = inputValue[0];
    this.isReadyForUpload = file.name.indexOf('.csv') > -1 || file.name.indexOf('.CSV')> -1;
    if (this.isReadyForUpload) {
      this.fileForUpload = file;
    }
  }

  private uploadFile()  {
    console.log(this.maklerPaket.wert);
    this.csvUploadService.secureUploadFile(this.fileForUpload, this.maklerPaket.wert, this.maklerPaket.text, this.gezeichneteProd.bezeichnung)
              .subscribe(
      (result:MaklerPaketStatus) => {
        console.log("to result?");
        if(result!=null) {
          console.log(result);
          this.isStatusDisplayMainPage=true;
          this.maklerStatus=result;
          this.isReadyForUpload=false;
        }
      }
    );
  }

}


